import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGame";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { Scale } from 'react-scaling';
import { Textfit } from 'react-textfit';
import Emile1 from "../../assets/NumberSense/Images/emile1.png";
import Emile2 from "../../assets/NumberSense/Images/emile2.png";
import Emile3 from "../../assets/NumberSense/Images/emile3.png";
import Emile4 from "../../assets/NumberSense/Images/emile4.png";
import Emile5 from "../../assets/NumberSense/Images/emile5.png";
import aimee1 from "../../assets/NumberSense/Images/aimee1.png";
import aimee2 from "../../assets/NumberSense/Images/aimee2.png";
import aimee3 from "../../assets/NumberSense/Images/aimee3.png";
import aimee4 from "../../assets/NumberSense/Images/aimee4.png";
import aimee5 from "../../assets/NumberSense/Images/aimee5.png";
import rocket1 from "../../assets/NumberSense/Images/rocket1.png";
import rocket2 from "../../assets/NumberSense/Images/rocket2.png";
import rocket3 from "../../assets/NumberSense/Images/rocket3.png";
import rocket4 from "../../assets/NumberSense/Images/rocket4.png";
import rocket5 from "../../assets/NumberSense/Images/rocket5.png";
import scrambler1 from "../../assets/NumberSense/Images/scrambler1.png";
import scrambler2 from "../../assets/NumberSense/Images/scrambler2.png";
import scrambler3 from "../../assets/NumberSense/Images/scrambler3.png";
import scrambler4 from "../../assets/NumberSense/Images/scrambler4.png";
import scrambler5 from "../../assets/NumberSense/Images/scrambler5.png";
import triangle1 from "../../assets/NumberSense/Images/triangle1.png";
import triangle2 from "../../assets/NumberSense/Images/triangle2.png";
import triangle3 from "../../assets/NumberSense/Images/triangle3.png";
import triangle4 from "../../assets/NumberSense/Images/triangle4.png";
import triangle5 from "../../assets/NumberSense/Images/triangle5.png";
import rectangle1 from "../../assets/NumberSense/Images/rectangle1.png";
import rectangle2 from "../../assets/NumberSense/Images/rectangle2.png";
import rectangle3 from "../../assets/NumberSense/Images/rectangle3.png";
import rectangle4 from "../../assets/NumberSense/Images/rectangle4.png";
import rectangle5 from "../../assets/NumberSense/Images/rectangle5.png";
import Table from "../../assets/NumberSense/Images/tableratios.png";


function ReturnRatioImage(image, number) {
  if (image == "Emile") {
    if (number == 1) {
      return Emile1;
    }
    if (number == 2) {
      return Emile2;
    }
    if (number == 3) {
      return Emile3;
    }
    if (number == 4) {
      return Emile4
    }
    if (number == 5) {
      return Emile5
    }
  }
  if (image == "Aimee") {
    if (number == 1) {
      return aimee1;
    }
    if (number == 2) {
      return aimee2;
    }
    if (number == 3) {
      return aimee3;
    }
    if (number == 4) {
      return aimee4
    }
    if (number == 5) {
      return aimee5
    }
  }
  if (image == "Triangle") {
    if (number == 1) {
      return triangle1;
    }
    if (number == 2) {
      return triangle2;
    }
    if (number == 3) {
      return triangle3;
    }
    if (number == 4) {
      return triangle4
    }
    if (number == 5) {
      return triangle5
    }
  }
  if (image == "Scrambler") {
    if (number == 1) {
      return scrambler1;
    }
    if (number == 2) {
      return scrambler2;
    }
    if (number == 3) {
      return scrambler3;
    }
    if (number == 4) {
      return scrambler4
    }
    if (number == 5) {
      return scrambler5
    }
  }
  if (image == "Rectangle") {
    if (number == 1) {
      return rectangle1;
    }
    if (number == 2) {
      return rectangle2;
    }
    if (number == 3) {
      return rectangle3;
    }
    if (number == 4) {
      return rectangle4
    }
    if (number == 5) {
      return rectangle5
    }
  }
  if (image == "Rocket") {
    if (number == 1) {
      return rocket1;
    }
    if (number == 2) {
      return rocket2;
    }
    if (number == 3) {
      return rocket3;
    }
    if (number == 4) {
      return rocket4
    }
    if (number == 5) {
      return rocket5
    }
  }
}
//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;

//used for smart allocation - refeed
var refeedQuestions = [];
var repeating = false;
var lastQuestion = "";
var questionCounter = 0;

//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function AddGrams(qText){
  console.log(qText);
  let arr = qText.split(' ');
  var checker;
  var newText = '';

  for(var i = 0; i < arr.length; i++){
    checker = arr[i];
    if(!isNaN(+checker)){
      if(checker >= 1){
      console.log(checker);
      arr[i] = checker + 'g';
      }
    }
  }


  for(var i = 0; i < arr.length; i++){
    newText += arr[i] + ' ';
  }
  console.log(newText);
  return newText;


}

function GenQuestion(q) {
  console.log(q.right_answer);
  //All the shared variables
  let questionAnswers = [];
  //Add the correct answer
  questionAnswers.push({ correct: true, value: q.right_answer });
  //Add the wrong answers
  questionAnswers.push({ correct: false, value: q.wrong_answer_1 });
  questionAnswers.push({ correct: false, value: q.wrong_answer_2 });
  questionAnswers.push({ correct: false, value: q.wrong_answer_3 });
  var html;

  //question html if topic = Ratio1
  if (q.topic_key == "Ratio1") {
    var images = q.images.split(":");
    var amounts = q.right_answer.split(":");
    html = '<img src="' + ReturnRatioImage(images[0], parseInt(amounts[0])) + '"' + "style='position:relative ; transform: scale(0.8,0.8) ; right:0% ; zIndex:-1'" + '></img>';
    html += '<img src="' + ReturnRatioImage(images[1], parseInt(amounts[1])) + '"' + "style='position:relative ; transform: scale(0.8,0.8) ; right:0% ; zIndex:-1'" + '></img>';
  }
  if (q.topic_key == "Ratio3") {
    var table = q.images.split(",");
    table[0] = table[0].replace("Table of ", "");
    html = '<img src="' + Table + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<b style='font-size:19px ; color:#815B37FF; position:absolute ; top:34% ; right:50.9%'>" + table[0] + "</b>" +
      "<b style='font-size:19px ; color:#815B37FF; position:absolute ; top:63% ; right:50.9%'>" + table[1] + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:34% ; right:40.5%'>" + table[2] + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:63% ; right:40.5%'>" + table[3] + "</b>";
  }

  shuffleArray(questionAnswers);
  console.log(q.question_line_2);

  if(q.topic_id == "1772"){
    let questionObj = {
      question: AddGrams(q.question_line_1),
      question2: q.question_line_2,
      answers: questionAnswers,
      topic_id: q.topic_id,
      questionHTML: html
    };
    return questionObj;

  }else{
    let questionObj = {
      question: q.question_line_1,
      question2: q.question_line_2,
      answers: questionAnswers,
      topic_id: q.topic_id,
      questionHTML: html
    };
    return questionObj;
}
 
}

export default function Practice({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const [nofeedback, setNoFeedback] = useState([]);
  const { questions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [extraChars, setExtraChars] = useState([]);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(-10);

  var timer = -1;
  if(props.timelimit > 0)
  {
      timer = props.timelimit;
  }
  else
  {
      timer = 60;
  }
  
  var questionMax = -1;
  if(props.minimum > 0)
  {
      questionMax = props.minimum;
  }
  
  //if question counter is higher than 3 then reset -refeed
  if(questionCounter > 3){
      questionCounter = 0;
  }

  
   //Sets the question to a new one
  function newQuestion() {
        
        currQuestion = GenQuestion(questions[Math.floor(Math.random() * questions.length)]); 

        //Debugging
        /*
        console.log("tst: lastQ: " + lastQuestion);
        console.log("tst: currQ: " + currQuestion.question);
        console.log("tst: Counter: " + questionCounter);
       */
 
        //get refeed question
        var loop = true;
        if (questionCounter === 2 && refeedQuestions[0] != undefined) {
            repeating = true;
            questionCounter = 0;
            currQuestion = refeedQuestions[refeedQuestions.length - 1];
            loop = false;
        }
        else
        {
            //if current quesiton is same as the previous question then reloop -refeed  
         while(loop){
            if (currQuestion.question.toString() === lastQuestion.toString()) { 
               // console.log("tst: I have looped!");
                currQuestion = GenQuestion(questions[Math.floor(Math.random() * questions.length)]); 
            }
            else{
              // console.log("tst: Good to go!");
               loop = false; 
               break;
		    }
		 }   
        } 
        setCurrentQuestion(currQuestion);
    }

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  //When clicking back or leaving the game result reset the array so it doesn't set the question to one from a previous game. -refeed
  function Reset() {
        refeedQuestions = [];
        questionCounter = 0;
        lastQuestion = "";
        console.log("RESET");
  }

  //Called on click
  async function checkResult(value, callback) {

  //set the current question to the last question -refeed
    questionCounter = questionCounter +1;
    lastQuestion = currQuestion.question;

    var isCorrect = true;
    if (value) {
      console.log(value.correct + " " + currQuestion.correct);
      console.log(currQuestion);
      //correct answer
      if (value.correct == true) {
        setCorrectQuestions([...correctQuestions, currQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }
        //if refeed question is repeating and the user gets the refeed question right, then remove current re feed question from refeed array - refeed
        if (repeating) {
         refeedQuestions.pop();
         repeating = false;
        }

        let qstring = currQuestion.question + " " + ( currQuestion.question2 !== undefined ? currQuestion.question2 : "")

        let result = {
          question: qstring,
          correct: currQuestion.correct,
          incorrect: value.value
      };
      setNoFeedback([...nofeedback, result]);

        newQuestion();
      }
      //incorrect answer
      else {
          isCorrect = false;
          questionCounter = 0;
        //push question to refeed if user gets it wrong - refeed
        refeedQuestions.push(currQuestion);

        setIncorrectQuestions([...incorrectQuestions, currQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }

        let qstring = currQuestion.question + " " + ( currQuestion.question2 !== undefined ? currQuestion.question2 : "")

        let result = {
          question: qstring,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }

      //Generates a new question
      //newQuestion();

    }
  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else if (waitTime != -10){

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      var sample = GenQuestion(questions[Math.floor(Math.random() * questions.length)]);
      currQuestion = sample;
      setCurrentQuestion(sample);
    }
  }, [questions]);

  //No clue
  useEffect(() => {
    if (status !== undefined && status === "OK") {
      setLoading(false);
    }
  }, [status]);

  function ComboImage() {
    console.log(props);
    let comboNum = combo;
    if (combo > 4)
      comboNum = 4;

     return (require("../../assets/Ratios/Animation" + "/combo" + comboNum + ".gif"));

  }


  //I don't know how to comment html/CSS
  return (
    <>
      <PracticeGame
        parent={props}
        correct={correctQuestions}
        incorrect={incorrectQuestions}
        score={score}
        defaultTimer={timer}
        questionLimit={questionMax}
        onBack={() => {
        Reset();
        props.onBack();
        }}
        loading={loading}
        feedback={feedback}
        nofeedback={nofeedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
          setIncorrectQuestions([]);
          Reset();
        }}
      >
        <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
          <Scale scaleTo={2000}>
            <Body>
              <div style={{ width: "80%" }}>
                {currQuestion !== undefined ? (


                  <Container currimg={currentQuestion.questionHTML}>
                    <div>
                      <div style={{ display: "flex", flexDirection: "row", }}>
                        <Question
                          type="text"
                          disabled
                          javaScriptEnabled={true}
                          //I don't know if this does anything
                          value={
                            currQuestion.question !== undefined
                              ? <div dangerouslySetInnerHTML={((currQuestion.question.replace("$", "?")))} />
                              : ""
                          }
                        >
                          <Textfit mode="multi" max="99" style={{ height: "100%" }}> 
                        <div dangerouslySetInnerHTML={{ __html: (currQuestion.question) }}></div>
                        </Textfit>
                        </Question>
                      </div>
                      {currentQuestion.question2 !== undefined && currentQuestion.question2 !== "" ?
                        <Question
                          type="text"
                          disabled
                          value={
                            currentQuestion.question2 !== undefined
                              ? currentQuestion.question2.replace("$", "?")
                              : ""
                          }
                        ><Textfit mode="multi" max="40" style={{ height: "100%" }}><span>{<div dangerouslySetInnerHTML={{ __html: (currentQuestion.question2) }} />}</span></Textfit></Question>
                        : ""}

                        <DynamicStyle>
                          <div dangerouslySetInnerHTML={{ __html: currQuestion.questionHTML }}></div>
                        </DynamicStyle>

                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between"
                      }}
                    >
                      {showColouredFeedback == false && currQuestion.answers !== undefined &&
                        currQuestion.answers.map(answer => (
                          <Button
                            value={<div dangerouslySetInnerHTML={answer.value} />}
                            style={{ flex: 1, margin: "20px" }}
                            onClick={() => checkResult(answer, true)}
                          >
                            <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                          </Button>
                        ))}

                      {showColouredFeedback == true && currQuestion.answers !== undefined &&
                        currQuestion.answers.map(answer => (
                          <Button
                            value={<div dangerouslySetInnerHTML={answer.value} />}
                            style={{ flex: 1, margin: "20px" , ...(answer.correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
                          >
                            <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                          </Button>
                        ))}
                    </div>
                  </Container>

                ) : <h1>help</h1>}
              </div>
              <Combo>
                <span style={{ fontSize: "20px" }}>COMBO</span>
              </Combo>
            </Body>
          </Scale>
        </div>
      </PracticeGame>
    </>
  );
}

const Body = styled.div`
            width: 100%;
            height: 100%;
  background-image: url("${props => props.gameBackground}");
            background-size: cover;
            background-position: 0px -1px;
            display: flex;
            justify-content: center;
            padding-top: 100px;
          `;

const Result = styled.div`
            width: 100%;
            height: 100%;
            font-size: 5em;
            text-align: center;
            border: solid 2px #683d8c;
          `;

const Combo = styled.div`
            background: #4391bb;
            width: 120px;
            height: 120px;
            border-radius: 75px;
            border: solid #204b7b 4px;
            display: flex;
            flex-direction: column;
            text-align: center;
            color: #fff;
            justify-content: center;
            font-weight: 600;
            margin-left: 50px;
          `;

const Container = styled.div`
            width:100%;
            height:95%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-bottom:100px;
          `;

const Question = styled.div`
            background: #FFF;
            user-select: none;
            width: 90%;
            height: 120px;
            line-height: 90px;
            font-size: 4em;
            margin: 15px 25px;
            text-align: center;
            font-weight: 600;
            border: none;
            border-radius: 10px;
          `;

const Button = styled.div`
            text-align: center;
            width: 10%;
            height: 150px;
            line-height: 100px;
            font-size: 4em;
            margin: 5px;
            color: #fff;
            user-select: none;
            background: rgb(234, 146, 19);
            background: linear-gradient(
              0deg,
              rgba(234, 146, 19, 1) 0%,
              rgba(255, 186, 32, 1) 100%
            );
            border: 2px solid #e88f12;
            padding: 0.5em;
            box-sizing: border-box;
            border-radius: 0.25em;
            cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
        font - size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin - bottom: 0;
  }
`;

const DynamicStyle = styled.div`
text-align: center;
position: relative

.centered {
  position: realtive;
  top: 35%;
  //left: -15%;
  //width: 100%
  //text-align: center
  font-size 2em;
  //50%
`;
